import React from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from "@ant-design/icons";
import { useAuthStore } from "../../../../store/auth/auth";
import { deleteOwner } from "../../../../api/owners/deleteOwner";
import { Key } from "antd/lib/table/interface";
import "./styleDeleteOwner.css";

interface DeleteOwnerProps {
    open: boolean;
    owners: { UID: string }[];
    onOk: () => void;
    onCancel: () => void;
}
const DeleteOwnerModal: React.FC<DeleteOwnerProps> = ({ open, owners, onOk, onCancel }) => {
    const { user, SmartDVRToken } = useAuthStore();

    const handleOk = async () => {
        if (owners && SmartDVRToken && user) {
            try {
                const uid = owners.map(o => o.UID);
                const response = await deleteOwner(SmartDVRToken, user.login, { uid });
                if (!response.success) {
                    console.error('Error deleting owner:', response.error);
                }
                onOk();
            } catch (error) {
                console.error('Error deleting owner:', error);
            }
        } else {
            console.warn('data is missing');
        }
    };

    const handleOnCancel = () => {
        onCancel()
    }

    return (
        <Modal
            title={
                <div className="titleOwner">
                    <span className="spanOwner">Удаление владельцев</span>
                    <CloseOutlined onClick={onCancel} className="closeBut_Owner" />
                </div>
            }
            className="deleteOwner_modal"
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            closable={false}
            footer={
                <>
                    <Button className="buttonYes" onClick={handleOnCancel}>Нет</Button>
                    <Button className="buttonNo" onClick={handleOk}>Да</Button>
                </>
            }
        >
            <span> Удалить {owners.length} владельца? </span>
        </Modal>
    );
};
export default DeleteOwnerModal; 